import { render, staticRenderFns } from "./OptionColor.vue?vue&type=template&id=97ecb4fe&scoped=true&"
import script from "./OptionColor.vue?vue&type=script&lang=js&"
export * from "./OptionColor.vue?vue&type=script&lang=js&"
import style0 from "./OptionColor.vue?vue&type=style&index=0&id=97ecb4fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ecb4fe",
  null
  
)

export default component.exports